// Index route for /bet/inplay — all UI handled by parent layout
export default function BetInPlayIndex() {
  return null;
}
